<template>
    <div class="md-layout">

        <zoom-center-transition :duration="1200" v-show="sitesForApproval.length > 0">
        <div class="md-layout-item md-size-100 header text-center">
             <h2 class="title">Awaiting Approval</h2>
             <p>Please approve the following websites for go live</p>
            <transition-group type="transition" name="list-complete" tag="div" class="md-layout">
            <site-for-approval-card v-for="web in sitesForApproval" :website="web" :key="web.id" 
                          @approveWebsite="approveWebsite"
                          class="list-complete-item md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-25"></site-for-approval-card>
            </transition-group>
        </div>
        </zoom-center-transition>
    
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            <stats-card header-color="warning">
                <template slot="header">
                    <div class="card-icon">
                        <md-icon>assignment</md-icon>
                    </div>
                    <p class="category">Portfolios</p>
                    <h3 class="title">
                        <animated-number-old :value="portfoliosCount"></animated-number-old>
                    </h3>
                </template>

                <template slot="footer">
                    <div class="stats">
                        <md-icon>add</md-icon>
                        <router-link to="/portfolios/new" class="btn_link">Add Portfolio/Client...</router-link>
                    </div>
                </template>
            </stats-card>
        </div>

        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            <stats-card header-color="blue">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-building"></i>
                    </div>
                    <p class="category">Buildings</p>
                    <h3 class="title">
                        <animated-number-old :value="buildingsCount"></animated-number-old>
                    </h3>
                </template>

                <template slot="footer">
                    <div class="stats">
                        <md-icon>list</md-icon>
                        <router-link to="/buildings" class="btn_link">View Buildings...</router-link>
                    </div>
                </template>
            </stats-card>
        </div>

        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            <stats-card header-color="rose">
                <template slot="header">
                    <div class="card-icon">
                        <md-icon>equalizer</md-icon>
                    </div>
                    <p class="category">Total Service Charges</p>
                    <h3 class="title">
                        &pound; <animated-number :value="totalServiceCharges" :formatValue="formatWithCommas" :round="1" :duration="800" />
                    </h3>
                </template>

                <template slot="footer">
                    <div class="stats">
                        <i class="fas fa-chart-line"></i>
                        Expected in next <animated-number-old :value="12"></animated-number-old> Months
                    </div>
                </template>
            </stats-card>
        </div>

        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            <stats-card header-color="green">
                <template slot="header">
                    <div class="card-icon">
                        <i class="fas fa-pound-sign"></i>
                    </div>
                    <p class="category">Total Management Fees</p>
                    <h3 class="title">
                        &pound; <animated-number :value="totalManagementFees" :formatValue="formatWithCommas" :round="1" :duration="800" />
                    </h3>
                </template>

                <template slot="footer">  
                    <div class="stats">
                        <md-icon>local_offer</md-icon>
                        Expected in next 12 Months
                    </div>
                </template>
            </stats-card>
        </div>


        <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS-->
        <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS--> <!--START CHARTS-->
        <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS--> <!--MINI CHARTS-->


        <div class="md-layout-item md-size-33 md-small-size-100">
            <chart-js-card header-animation="false"
                           chart-inside-header
                           no-footer
                           background-color="warning">
                <template slot="chartInsideHeader">
                    <bar-chart :chart-data="scByPortfolio.data" :options="scByPortfolio.options" :height="scByPortfolio.height" :width="scByPortfolio.width" class="chart-js-chart" />
                </template>
                <template slot="content">
                    <h4 class="title">
                        {{scByPortfolio.title}}
                    </h4>
                    <p class="category">
                        {{scByPortfolio.subtitle}}
                    </p>
                </template>
            </chart-js-card>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100 tenByPort-chart">
            <chart-js-card header-animation="false"
                           chart-inside-header
                           no-footer
                           background-color="rose">
                <template slot="chartInsideHeader">
                    <bar-chart :chart-data="tenantsByPortfolio.data" :options="tenantsByPortfolio.options" :height="tenantsByPortfolio.height" :width="tenantsByPortfolio.width" class="chart-js-chart" />
                </template>
                <template slot="content">
                    <h4 class="title">
                        {{tenantsByPortfolio.title}}
                    </h4>
                    <p class="category">
                        {{tenantsByPortfolio.subtitle}}
                    </p>
                </template>
            </chart-js-card>
        </div>

        <div class="md-layout-item md-size-33 md-small-size-100">
            <chart-js-card header-animation="false"
                           chart-inside-header
                           no-footer
                           background-color="green">
                <template slot="chartInsideHeader">
                    <line-chart :chart-data="oneOffFees.data" :options="oneOffFees.options"
                                :height="oneOffFees.height" class="chart-js-chart" :width="oneOffFees.width" style="width:100%;" />
                </template>

                <template slot="content">
                    <h4 class="title">
                        {{oneOffFees.title}}
                    </h4>
                    <p class="category">
                        {{oneOffFees.subtitle}}
                    </p>
                </template>
            </chart-js-card>
        </div>


        <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS--> <!--END MINI CHARTS-->

        <div class="md-layout-item md-size-50 md-small-size-100">
            <chart-js-card header-animation="false"
                           header-icon
                           chart-inside-content
                           background-color="green">
                <template slot="chartInsideHeader">
                    <div class="card-icon">
                        <md-icon>insert_chart</md-icon>
                    </div>
                    <h4 class="title">
                        {{ budgetPacks.title }} <small> - {{ budgetPacks.subtitle }}</small>
                    </h4>
                </template>


                <template slot="content">
                    <bar-chart :chart-data="budgetPacks.data" :options="budgetPacks.options"
                               :height="budgetPacks.height" :width="budgetPacks.width" class="chart-js-chart" />
                </template>

                <template slot="footer">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <i class="fa fa-circle text-success"></i> Done
                            <i class="fa fa-circle text-warning"></i> Due
                            <i class="fa fa-circle text-danger"></i> Overdue
                            <i class="fa fa-circle text-gray"></i> Upcoming
                        </div>
                    </div>
                </template>

            </chart-js-card>
        </div>



        <div class="md-layout-item md-size-50 md-small-size-100">
            <chart-js-card header-animation="false"
                           header-icon
                           chart-inside-content
                           background-color="blue">
                <template slot="chartInsideHeader">
                    <div class="card-icon">
                        <md-icon>insert_chart</md-icon>
                    </div>
                    <h4 class="title">
                        {{ gapAnalysis.title }} <small> - {{ gapAnalysis.subtitle }}</small>
                    </h4>
                </template>


                <template slot="content">
                    <bar-chart :chart-data="gapAnalysis.data" :options="gapAnalysis.options"
                               :height="gapAnalysis.height" :width="gapAnalysis.width" class="chart-js-chart" />
                </template>

                <template slot="footer">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <span v-for="port in gapAnalysisLegendData" :key="port.key">
                                <i class="fa fa-circle" :style="'color:'+port.color+';'"></i>
                                {{port.name}}
                            </span>
                            <div v-if="gapAnalysisLegendData.length == 0" class="legend_spacer">&nbsp;</div>
                        </div>
                    </div>
                </template>
            </chart-js-card>
        </div>



        <div class="md-layout-item md-size-50 md-small-size-100">
            <chart-js-card header-animation="false"
                           header-icon
                           chart-inside-content
                           background-color="blue">
                <template slot="chartInsideHeader">
                    <div class="card-icon">
                        <i class="fas fa-pencil-alt"></i>
                    </div>
                    <h4 class="title">
                        {{ tasks.title }} <small> - {{ tasks.subtitle }}</small>
                    </h4>
                </template>

                <template slot="content">
                    <div v-if="!tasksHasData" class="chartjs_no_data" :style="'height:'+tasks.height+'px;'"><h2>No Data</h2></div>
                    <horizontal-bar-chart v-else :chart-data="tasks.data" :options="tasks.options"
                                          :height="tasks.height" :width="tasks.width" class="chart-js-chart" />
                </template>

                <template slot="footer">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <i class="fa fa-circle text-success"></i> Completed
                            <i class="fa fa-circle text-gray"></i> Outstanding
                        </div>
                    </div>
                </template>

            </chart-js-card>
        </div>



        <div class="md-layout-item md-size-50 md-small-size-100">
            <chart-js-card header-animation="false"
                           header-icon
                           chart-inside-content
                           background-color="gray">
                <template slot="chartInsideHeader">
                    <div class="card-icon">
                        <md-icon>language</md-icon>
                    </div>
                    <h4 class="title">
                        {{ websites.title }} <small> - {{ websites.subtitle }}</small>
                    </h4>
                </template>


                <template slot="content">
                    <div v-if="!websitesHasData" class="chartjs_no_data" :style="'height:'+websites.height+'px;'"><h2>No Data</h2></div>
                    <donut-chart  v-else :chart-data="websites.data" :options="websites.options"
                                 :height="websites.height" :width="websites.width" class="chart-js-chart" />
                </template>

                <template slot="footer">
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <i class="fa fa-circle text-semi-success"></i> Generating
                            <i class="fa fa-circle text-warning"></i> Awaiting Payment
                            <i class="fa fa-circle text-danger"></i> Awaiting Approval
                            <i class="fa fa-circle text-success-ish"></i> Publishing
                            <i class="fa fa-circle text-success"></i> Live
                        </div>
                    </div>
                </template>

            </chart-js-card>
        </div>


     
        <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS-->
        <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS--> <!--BUILDINGS BUILDINGS-->

         <dash-websites class="md-layout-item md-size-100 md-small-size-100"
                       :sites="sites"
                       :sitePortfolios="sitePortfolios"
                       ></dash-websites>

    </div>
</template>

<script>
      
    import ChartHelp from "@/ts/chartHelp";
    import Help from "@/ts/Help";
    import Api from '@/ts/UvApiService';
    import AnimatedNumber from "animated-number-vue";
    import DashWebsites from "./DashWebsites.vue";

    import { ZoomCenterTransition } from "vue2-transitions";
    import NotyTypes from "@/ts/NotyTypes";

    import {
        StatsCard,
        AnimatedNumberOld,
        LineChart,  
        BarChart,
        HorizontalBarChart,
        DonutChart,
        ChartJsCard,
        SiteForApprovalCard,
    } from "@/components";

    export default {
        components: {
            StatsCard,
            AnimatedNumberOld,
            LineChart,
            BarChart,
            HorizontalBarChart,
            DonutChart,
            ChartJsCard,
            AnimatedNumber,
            DashWebsites,
            SiteForApprovalCard,
            ZoomCenterTransition
        },
        async beforeRouteEnter(to, from, next) {
            var chartData = await Api.dashboard.getData();
            next(vm => vm.setData(chartData));
        },
        methods:
        {
            async approveWebsite (website) {
                var res = await Api.dashboard.approveWebsite(website.id);//TODO:TODAY this is an admin only server function.
                if (res.success === true) {

                    Help.removeItemFromArray(this.sitesForApproval, website);

                    this.$notify({
                        timeout: 10000,
                        message: res.message,
                        icon: "thumb_up",
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: NotyTypes[NotyTypes.success],
                          animate: {
                            enter: 'animated fadeInDown',
                            exit: 'animated fadeOutUp'
                        }
                    });
                   
                }
                else {
                    this.showServerFailMessage(res, "approving", "website");
                }

                 this.$notify({
                        timeout: 5000,
                        message: "Refreshing data...",
                        icon: "add_alert",
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: NotyTypes[NotyTypes.info],
                          animate: {
                            enter: 'animated fadeInDown',
                            exit: 'animated fadeOutUp'
                        }
                    });

                var chartData = await Api.dashboard.getData();
                this.setData(chartData);
            },

            showServerFailMessage(res, action, subject) {
                var msg = res.message ?? `Unknown problem on the server ${action} this ${subject}`;
                this.$notify({
                    timeout: 10000,
                    message: msg,
                    icon: "add_alert",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: NotyTypes[NotyTypes.danger]
                });
            },

            formatWithCommas(value) {
                return new Intl.NumberFormat({ style: 'currency' }).format(value);
            },

            //resetSitesFilters() {
            //    this.sitesPortfolioIdChosen = false;
            //    this.sitesSelectedLetter = null;
            //    this.sitesSearch = '';
            //},

            //selectLetter(theLetter) {
            //    if (this.sitesSelectedLetter === theLetter) {
            //        this.sitesSelectedLetter = null;
            //    }
            //    else {
            //        this.sitesSelectedLetter = theLetter;
            //    }
            //},

            setData(chartData) {

                this.sitesForApproval = chartData.sitesForApproval;

                this.portfoliosCount = chartData.portfoliosCount;
                this.buildingsCount = chartData.buildingsCount;
                this.totalServiceCharges = chartData.totalServiceCharges;
                this.totalManagementFees = chartData.totalManagementFees;

                this.scByPortfolio.data = ChartHelp.mergeChartData({
                    labels: [],
                    datasets: [
                        {
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            barPercentage: 0.3
                        }]
                }, chartData.scByPortfolio);

                this.tenantsByPortfolio.data = ChartHelp.mergeChartData({
                    labels: [],
                    datasets: [
                        {
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            barPercentage: 0.3
                        }]
                }, chartData.tenantsByPortfolio);

                this.oneOffFees.data = ChartHelp.mergeChartData({
                    datasets: [
                        {
                            backgroundColor: "#FFFFFF",
                            borderColor: "#FFFFFF",
                            fill: false,
                            lineTension: 0, 
                        }]
                }, chartData.oneOffFees);

                this.gapAnalysis.data = ChartHelp.mergeChartDataForNDatasetsAndColorize({
                        barPercentage: 1,
                        categoryPercentage: .35
                    }, chartData.gapAnalysis, ChartHelp.defaultPortfolioColors);;
                this.gapAnalysisLegendData = ChartHelp.getGapAnalysisLegendData(chartData.portfolioNames);

                this.tasks.data = ChartHelp.mergeChartDataForNDatasetsAndColorize({ barPercentage: 0.6 },
                    chartData.tasks, ChartHelp.defaultTaskColors);
                this.tasksHasData = chartData.tasksHasData;

                this.websites.data = ChartHelp.mergeChartDataForNDatasets({
                    backgroundColor: ChartHelp.defaultWebsiteStatusColors,
                    borderWidth: 0,
                }, chartData.websites);
                this.websitesHasData = chartData.websitesHasData;

                this.budgetPacks.data = ChartHelp.mergeChartDataForNDatasetsAndColorize({ barPercentage: 0.4 },
                    chartData.budgetPacks, ChartHelp.defaultDueStatusColors);

                this.sitePortfolios = chartData.sitePortfolios;
                this.sites = chartData.sites;
            },
        },
        computed: {

            //displaySitesResetFiltersOption() {
            //    return this.sites.length > 0;
            //},

            //computedSitesList: function () {
            //    var self = this;
            //    return this.sites.filter(function (web) {
            //        var matchingFirstLetter = Help.isGoodString(self.sitesSelectedLetter)? web.firstLetter === self.sitesSelectedLetter : true;
            //        var matchingPortfolioId = Help.isGoodNumber(self.sitesPortfolioIdChosen) ? web.portfolioId === self.sitesPortfolioIdChosen : true;
            //        var matchingSearchTerm = Help.isGoodString(self.sitesSearch)? web.name.toLowerCase().indexOf(self.sitesSearch.toLowerCase()) !== -1 : true;
            //        return matchingFirstLetter && matchingPortfolioId && matchingSearchTerm;
            //    });
            //}
        },  
        data() {
            return {
                sitesForApproval: [],
                //sitesPortfolioIdChosen: false,
                //sitesSelectedLetter: null,
                //sitesSearch: '',
                sitePortfolios: [],
                //alphabet: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],


                sites: [],

                portfoliosCount: 0,
                buildingsCount:0,
                totalServiceCharges: 0,
                totalManagementFees: 0,

                gapAnalysisLegendData: [],
                tasksHasData: false,
                websitesHasData: false,

             



                scByPortfolio: {
                    title: "S/C by Portfolio",
                    subtitle: "Service Charge by Portfolio",
                    height: 150,
                    width: 500,  
                    data: ChartHelp.defaultEmptyData(),
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: { display: false },
                        title: { display: false },
                        layout: ChartHelp.defaultMiniChartLayout(),
                        scales: {
                            xAxes: [{
                                gridLines: ChartHelp.defaultChartGridLinesX(),
                                scaleLabel: { display: false },
                                ticks: ChartHelp.getTicks()
                            }],
                            yAxes: [{
                                gridLines: ChartHelp.defaultMiniChartGridLinesY(),
                                scaleLabel: { display: false },
                                ticks: ChartHelp.getTicks(ChartHelp.dynamicNumericTickLabels, { beginAtZero: true, padding: 10, precision: 0, suggestedMax: 1 })
                            }]
                        },
                        // DIFF
                        tooltips: {
                            displayColors: ChartHelp.defaultMiniChartTooltipDisplayColors,
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    return ChartHelp.currencyFormatLabel(tooltipItem, data);
                                }
                            }
                        }
                    }
                },
                tenantsByPortfolio: {
                    title: "Tenants by Portfolio",
                    subtitle: "Total Tenants in Each Portfolio",
                    height: 150,
                    width: 500,
                    data: ChartHelp.defaultEmptyData(),
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: { display: false },
                        title: { display: false },
                        layout: ChartHelp.defaultMiniChartLayout(),
                        scales: {
                            xAxes: [{
                                gridLines: ChartHelp.defaultChartGridLinesX(),
                                scaleLabel: { display: false },
                                ticks: ChartHelp.getTicks()
                            }],
                            yAxes: [{
                                gridLines: ChartHelp.defaultMiniChartGridLinesY(),
                                scaleLabel: { display: false },
                                ticks: ChartHelp.getTicks(ChartHelp.dynamicNumericTickLabels, { beginAtZero: true, padding: 10, precision: 0, suggestedMax: 1 })
                            }]
                        },
                        tooltips: {
                            displayColors: ChartHelp.defaultMiniChartTooltipDisplayColors
                        }
                    }
                },
                oneOffFees: {
                    title: "One-Off Billing",
                    subtitle: "Billed One Off Fees / Month",
                    height: 150,
                    width: 500,
                    data: ChartHelp.defaultEmptyData(),
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: { display: false },  
                        title: { display: false },
                        hover: { mode: 'nearest', intersect: true },
                        layout: ChartHelp.defaultMiniChartLayout(),
                        scales: {
                            xAxes: [{
                                gridLines: ChartHelp.defaultChartGridLinesX(),
                                scaleLabel: { display: false },
                                ticks: ChartHelp.getTicks(function (value, index, values) {
                                    return value.substring(0, 1);
                                })
                            }],
                            yAxes: [{
                                gridLines: ChartHelp.defaultMiniChartGridLinesY(),
                                scaleLabel: { display: false },
                                ticks: ChartHelp.getTicks(ChartHelp.dynamicNumericTickLabels, { beginAtZero: true, padding: 10, precision: 0, suggestedMax: 1 })
                                //ticks: ChartHelp.getTicks(function (value, index, values) {
                                //    return (value / 1000) + 'k';
                                //}, { beginAtZero: true, precision: 0, suggestedMax:10, padding: 10, stepSize: 10000 })
                            }]
                        },
                        tooltips: {
                            mode: 'index', intersect: false, displayColors: ChartHelp.defaultMiniChartTooltipDisplayColors,
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    return ChartHelp.currencyFormatLabel(tooltipItem, data);
                                }
                            }
                        }
                    }
                },

                budgetPacks: { //TODO: popup with list of buildings in col  - Cols = Status, Building, Portfolio, Due Date  (days overdue?)
                    title: "Budget Packs",
                    subtitle: "Due Dates",
                    height: 300,
                    width: 800,
                    data: ChartHelp.defaultEmptyData(),
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: { display: false },
                        title: { display: false },
                        scales: {
                            xAxes: [{
                                stacked: true,
                                gridLines: ChartHelp.getGridLinesX(),
                                ticks: ChartHelp.getTicks(function (value, index, values) {
                                    return [value.substring(0, 3), " "]; //N.B. this adds a second line to ensure Y axes zeropoint lines up with gap analysis chart
                                }, { fontColor: "rgba(0, 0, 0, 0.4)" }),
                                scaleLabel: { display: false }
                            }],
                            yAxes: [{
                                stacked: true,
                                gridLines: ChartHelp.getGridLinesY(),
                                ticks: ChartHelp.getTicks(undefined, { padding: 10, beginAtZero: true, precision: 0, suggestedMax:5, fontColor: "rgba(0, 0, 0, 0.4)" }),
                                scaleLabel: { display: false }
                            }]
                        },
                        tooltips: { backgroundColor: "#EEEEEE" }
                    }
                },

                gapAnalysis: { //TODO: popup with list of buildings in col  - Cols = Status, Building, Portfolio, Due Date  (days overdue?)
                    title: "Gap Analysis", 
                    subtitle: "Percent of Buildings with Service",
                    height: 300,
                    width: 800,
                    data: ChartHelp.defaultEmptyData(),
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: { display: false },
                        title: { display: false },
                        scales: {
                            xAxes: [{
                                gridLines: ChartHelp.getGridLinesX(),
                                ticks: ChartHelp.getTicks(function (value, index, values) { //TODO:TD this breaks txt up into multilines should post here an answer pointing ouyt his sln adds comms to tooltips in current version - but mine does not https://stackoverflow.com/questions/53858517/chartjs-break-line-for-axes-tick-labels-text
                                    var respVal = value;
                                    var txtLength = value.length; //cref:https://stackoverflow.com/a/39706742/661584 ??
                                    if (txtLength > 5) {
                                        respVal = Help.splitStringOnWhitepace(value);
                                    }
                                    return respVal;
                                }, { fontColor: "rgba(0, 0, 0, 0.4)" }),
                                scaleLabel: { display: false },
                             
                            }],
                            yAxes: [{
                                gridLines: ChartHelp.getGridLinesY(),
                                scaleLabel: { display: false },
                                ticks: ChartHelp.getTicks(undefined, { beginAtZero: true, padding: 10, precision: 0, suggestedMax: 100, fontColor: "rgba(0, 0, 0, 0.4)" })
                            }]
                        },
                        tooltips: { backgroundColor: "#EEEEEE" }
                    }
                },

                tasks: { //TODO: popup with list of buildings in col  - Cols = Status, Building, Portfolio, Due Date  (days overdue?)
                    title: "Tasks",
                    subtitle: "In Progress Buildings",
                    height: 230,
                    width: 800,
                    data: ChartHelp.defaultEmptyData(),
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: { display: false },
                        title: { display: false },
                        scales: {
                            xAxes: [{
                                stacked: true,
                                gridLines: ChartHelp.getGridLinesY(), //we sawp X and Y compared to defaults as this is horizontalStacked
                                ticks: ChartHelp.getTicks(undefined, { min: 0, stepSize: 25, padding: 10,  fontColor: "rgba(0, 0, 0, 0.4)" }),
                                scaleLabel: { display: false }
                            }],
                            yAxes: [{
                                stacked: true,
                                gridLines: ChartHelp.getGridLinesX(),
                                ticks: ChartHelp.getTicks(undefined, { reverse: true, fontColor: "rgba(0, 0, 0, 0.4)" }),
                                scaleLabel: { display: false }
                            }]
                        },
                        tooltips: { backgroundColor: "#EEEEEE", mode: 'point', intersect: true } //makes the tooltips behave like budgetPacks i.e. just the dataset hovered not both / all
                    }
                },

                websites: {
                    title: "Websites",
                    subtitle: "Completion Statuses",
                    height: 230,
                    width: 800,
                    data: ChartHelp.defaultEmptyData(),
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: { display: false },
                        title: { display: false },
                        cutoutPercentage: 65,
                        layout: {
                            padding: {
                                top: 40,
                                right: 0,
                                bottom: 40,
                                left: 0
                            }
                        },
                        plugins: {
                            // Change options for ALL labels of THIS CHART
                            datalabels: { //plugin chartjs-plugin-datalabels
                                color: 'rgba(0, 0, 0, 0.4)',
                                offset : 25,
                                align: 'end',
                                formatter: (value, ctx) => { //show labels as percentage
                                    let sum = 0;
                                    let dataArr = ctx.chart.data.datasets[0].data;
                                    dataArr.map(data => {
                                        sum += data;
                                    });
                                    let percentage = (value * 100 / sum).toFixed(0) + "%";
                                    return percentage;
                                },
                            }
                        }
                    },
                },
            };
        }
    };
</script>


<style>

    a.btn_link {
        color: gray !important;
        transition: color .25s;
    }

        a.btn_link:hover {
            color: darkblue !important;
        }

    .text-center {
        text-align: center;
    }

    .list_alphabet {
        width: 100%;
        list-style: none;
        display: flex;
        justify-content: space-between;
        padding: 0;
        margin: 0;
        margin-top: 1.5rem;
    }

        .list_alphabet li {
            flex-grow: 1;
            flex-basis: 0;
            cursor:pointer;
        }

            .list_alphabet li:hover,
            .list_alphabet li.selected
            {
                background: white;
            }

            .list_alphabet li a {
                color: black !important;
                width: 100%;
                height: 100%;
                display: inline-block;
            }

                .list_alphabet li a:hover {
                    color: indianred !important;
                }

    .price h4 small {
        font-weight: 300;
    }

    .text-gray {
        color: gray;
    }
    

    .chart-js-chart {
        font-weight: 100;
    }

    .chartjs_no_data {
        display: inline-block;
        width: 100%;
    }
        .chartjs_no_data h2 {
            text-align: center;
            margin-top: 75px;
            color: rgba(0,0,0,0.54);
        }

    .legend_spacer {
        height:24px;
    }

    .sites_list_empty {
        min-height: 380px;
    }

</style>